
import SupportTickets from "../components/superadmin/AdminSupport";

export default function SuperTicket() {
  return (
    <div>
      <SupportTickets />
    </div>
  );
}
